// @ts-strict-ignore
import { connect } from 'react-redux'
import { meta, pathname } from '../../redux/app-selectors'
import { breadcrumb, getModuleFromIncludes } from '../../redux/contentful-selectors'

import { pageTitle, contentId } from '../../utils/contentful'

export default (Component) =>
  connect((state) => {
    const pageId = contentId(state.contentful.ctx.items[0].fields.link)
    const page = getModuleFromIncludes(state.contentful.ctx.includes, pageId)
    const homeTitle = meta(state)?.breadcrumbs?.homeTitle
    const path = pathname(state)
    const customSeparatorSvg = meta(state)?.breadcrumbs?.separatorSvg
    const homePath = meta(state)?.breadcrumbs?.homePath

    const breadcrumbs = breadcrumb(state)
    const [pageCrumb] = breadcrumbs.slice(-1)

    const crumbs = breadcrumbs.filter((bc) => bc.fields.path !== path)
    const breadcrumbTitle =
      pageCrumb?.fields?.path === pathname(state) ? pageCrumb?.fields?.displayText : pageTitle(page)

    return {
      crumbs,
      title: meta(state)?.breadcrumbs?.showPageTitle ? breadcrumbTitle : null,
      ...(homeTitle ? { customHomeIcon: homeTitle } : {}),
      ...(customSeparatorSvg ? { customSeparatorSvg } : {}),
      homePath,
    }
  })(Component)
